<div class="tool-settings-paging">
  <div class="tool-settings-paging-description">Showing {{ fromCount }} to {{ toCount }} of {{ totalCount }}</div>
  <nav aria-label="Page navigation example">
    <ul class="pagination">
      <li [className]="'page-item' + (links?.prevPage === links?.currentPage && ' disabled')">
        <a class="page-link" (click)="performNavigation($event, 'prevPage')" href="javascript:;"> Previous </a>
      </li>

      <li
        [className]="'page-item' + (page === links?.currentPage && ' active')"
        *ngFor="let page of pageList"
        [attr.data-index]="page"
        (click)="performNavigation($event, page)">
        <a class="page-link" href="javascript:;">{{ isNumber(page) ? page : '...' }}</a>
      </li>

      <li [className]="'page-item' + (links?.nextPage === links?.currentPage && ' disabled')">
        <a class="page-link" (click)="performNavigation($event, 'nextPage')" href="javascript:;"> Next </a>
      </li>
    </ul>
  </nav>
</div>
